export default {
    nl: {
        intro: {
            subtitle: 'Design system',
            title: 'Efficiënter designen.',
            contact: 'Neem contact op',
            image: 'https://23g-website.s3.eu-central-1.amazonaws.com/services/design-system/hero.jpg',
        },
        type: 'Design system',
        title: 'Realiseer een consistent merk met ons design system',
        description:
            'Ontdek hoe we met een design system jouw merk tot leven brengen! Zorg voor consistentie en maak een product van onschatbare waarde.',
        content: [
            {
                type: 'text',
                title: 'Design system',
                content: `
                    Bij 23G zien we een design system als een essentieel hulpmiddel om een consistente merkbeleving te creëren.
                    <br><br>
                    Een design system is veel meer dan een huisstijlboek. Het fungeert als een levende gids met standaard designelementen en guidelines, waarin vastgestelde kleurcodes en uitgewerkte HTML-codes voor buttons en formulieren staan uitgewerkt. Ook iconen en het gebruik van lettertypes staan hierin opgeslagen. Centraal in het opzetten van een design system staat het creëren van een intuïtieve en gebruiksvriendelijke gebruikersinterface en gebruikerservaring, ofwel UI/UX design.
                    <br><br>
                    Deze gids combineert de huisstijl met webelementen. Het stelt het onze visual designers, developers en ook jou als klant in staat om richtlijnen te volgen en elementen te kopiëren voor direct gebruik bij het ontwikkelen en gebruiken van jouw product.
                `,
            },
            {
                type: 'images',
                images: [
                    'https://23g-website.s3.eu-central-1.amazonaws.com/services/styleguide.webp',
                ],
            },
            {
                type: 'text',
                title: 'Hoe Figma helpt bij het maken van een design system',
                content:
                    'Met behulp van het programma Figma creëren we onze digitale meesterwerken. Hier werken we aan jouw ontwerp en tegelijkertijd aan de opbouw van het design system. Dit zorgt voor consistentie in het ontwerp en levert uiteindelijk een hoop voordelen op. Je bespaart tijd en geld dankzij herbruikbare componenten en gestandaardiseerde richtlijnen die de ontwikkeltijd verkorten en foutjes tot een minimum beperken. Zo houden we samen meer tijd over om te focussen op wat echt telt: het realiseren van een product van onschatbare waarde.',
            },
            {
                type: 'quote',
                content:
                    'Design systEMS zijn als bouwstenen van creativiteit; ze bieden consistentie en flexibiliteit',
            },
            {
                type: 'list',
                title: 'Wat kun je met een design system?',
                items: [
                    'Ontwikkelingen in de digitale wereld? Met een design system garanderen we een consistente merkbeleving, overal en altijd.',
                    'Geen verwarring of discussie meer over het design; alles is duidelijk beschreven en vastgelegd in het systeem.',
                    'Designers en developers zijn helemaal in sync, communiceren effectief en zijn razendsnel op één lijn, zodat jij de beste resultaten krijgt!',
                ],
            },
            {
                type: 'image-big',
                image: 'https://23g-website.s3.eu-central-1.amazonaws.com/services/creating-design.webp',
            },
        ],
        related_services: ['visual-design', 'ux-research', 'front-end-development'],
        contact: {
            title: '',
            employee: 'michiel',
        },
    },
    en: {},
};
